import { render, staticRenderFns } from "./CommonMenuAside.vue?vue&type=template&id=d17d3d1a&scoped=true"
import script from "./CommonMenuAside.vue?vue&type=script&lang=js"
export * from "./CommonMenuAside.vue?vue&type=script&lang=js"
import style0 from "./CommonMenuAside.vue?vue&type=style&index=0&id=d17d3d1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17d3d1a",
  null
  
)

export default component.exports